
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import {
    FormGroup,
    FormArray,
    FormControl,
    Validators,
} from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil, finalize, map, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { BeneficiariService } from '../../beneficiari.service';
import {
    DosarCategoryIcons,
    ViewMode,
    InvolvedPerson,
    ViewCard,
    OrderMode,
} from './documente.model';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { helper } from 'src/environments/helper';
import { Beneficiar, FileGroup, FileUpload, UploadedFile } from '../../beneficiari.interface';
import { environment } from 'src/environments/environment';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { DocumentCategoriesService } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-categories/document-categories.service';
import { DocumentTagsService } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-tags/document-tags.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { ConditieMedicalaService } from 'src/app/platform/nomenclatoare/activities-setari/conditie-medicala/conditie-medicala.service';
import { EvenimentGenealogicService } from 'src/app/platform/nomenclatoare/activities-setari/eveniment-genealogic/eveniment-genealogic.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { RelatieTypeService } from 'src/app/platform/nomenclatoare/activities-setari/relatie-type/relatie-type.service';
import { RelatieSpecificaService } from 'src/app/platform/nomenclatoare/activities-setari/relatie-specifica/relatie-specifica.service';
import { DialogService } from 'src/app/services/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { AddDocumentTagsComponent } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-tags/add-document-tags/add-document-tags.component';
import Swal from 'sweetalert2';
import { DocumentSectionsService } from 'src/app/platform/nomenclatoare/activities-docs-setari/document-sections/document-sections.service';
import { dateRangeValidator } from 'src/app/validators/date-period';
import { ViewDocumentComponent } from './view-document/view-document.component';

interface Tag {
    id: number;
    name: string;
    color: string;
}

@Component({
    selector: 'app-documente',
    templateUrl: './documente.component.html',
    styleUrls: ['./documente.component.scss']
})
export class DocumenteComponent implements OnInit, OnChanges, OnDestroy {
    @Input() beneficiar!: Beneficiar;
    @Output() beneficiarChanged: EventEmitter<Beneficiar> = new EventEmitter<Beneficiar>();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    isLoading = false;
    showUploadPanel = false;
    uploading = false;

    // Edit data only
    editData: FileGroup | null = null;
    uploadedFiles: UploadedFile[] = []
    deletedFiles: UploadedFile[] = [];
    // Edit data only

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    eduStatus = [
        { name: '--Alegeți--', value: -1 },
        { name: 'În curs', value: 1 },
        { name: 'Finalizat', value: 2 },
        { name: 'Abandonat', value: 3 },
    ]

    form: FormGroup = new FormGroup({
        // General
        category_id: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        category_slug: new FormControl('', []),
        tag_id: new FormControl(-1, []),
        document_nr: new FormControl(''),
        document_date: new FormControl(null),
        observations: new FormControl(''),
        // Medical
        medical_section: new FormControl(-1),
        medical_condition_type: new FormControl(-1),
        genealogical_event_type: new FormControl(-1),
        doctor_name: new FormControl(''),
        clinic_name: new FormControl(''),
        diagnosis: new FormControl(''),
        treatment: new FormControl(''),
        date_next_checkup: new FormControl(null),
        // Educational
        institution_name: new FormControl(''),
        location: new FormControl(''),
        date_from: new FormControl(null),
        date_to: new FormControl(null),
        edu_status: new FormControl(-1),
        degree_type: new FormControl(''),
        specialization: new FormControl(''),
        has_breaks: new FormControl(false),
        break_details: new FormControl(''),
        // Juridic 
        court_name: new FormControl(''),
        // Psihologic
        specialist_name: new FormControl(''),
        evaluation_type: new FormControl(''),
        recommendations: new FormControl(''),
        // Familial
        document_subtype: new FormControl(''),
    }, { validators: dateRangeValidator('date_from', 'date_to') });

    involvedPersonForm: FormGroup = new FormGroup({
        full_name: new FormControl('', [Validators.required]),
        cnp: new FormControl('', [Validators.pattern('[0-9]{13}')]),
        relationship_type_id: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        relationship_type_name: new FormControl('', []),
        relationship_specific_id: new FormControl(-1, []),
        relationship_specific_name: new FormControl('', []),
        // role: new FormControl('', [Validators.required]),
        // relation: new FormControl(''),
    });

    filesForm: FormGroup = new FormGroup({
        files: new FormArray([], [Validators.required]),
    });

    // Involved persons for familial
    involvedPersons: InvolvedPerson[] = [];

    fileGroups: FileGroup[] = [];
    filteredFileGroups: FileGroup[] = [];
    viewCards: ViewCard[] = [];

    // Date filters
    readonly minDate = new Date(2018, 0, 1);
    readonly maxDate = new Date(2030, 11, 31);
    dateFrom = new FormControl<Date | null>(new Date(2018, 0, 1));
    dateTo = new FormControl<Date | null>(new Date(2030, 11, 31));

    documentCategories: (Generic & { slug: string })[] = [];
    documentSections: Generic[] = [];

    private destroy$ = new Subject<void>();

    tagArr: Tag[] = [];
    documentTags: Tag[] = [];
    filteredDocumentTags: Tag[] = [];
    documentTagsControl = new FormControl();

    // Tag Filter
    filterTags = new FormControl(-1);
    filteredSearchTags: Tag[] = [];
    searchTagsControl = new FormControl();

    conditieMedicala: Generic[] = [];
    filteredConditieMedicala: Generic[] = [];
    conditieMedicalaControl = new FormControl();

    evenimentGenealogic: Generic[] = [];
    filteredEvenimentGenealogic: Generic[] = [];
    evenimentGenealogicControl = new FormControl();

    relatieType: Generic[] = [];
    filteredRelatieType: Generic[] = [];
    relatieTypeControl = new FormControl();

    relatieSpecifica: Generic[] = [];
    filteredRelatieSpecifica: Generic[] = [];
    relatieSpecificaControl = new FormControl();

    activeCategory: string | null = null;
    activeCategorySelect: string | null = null;

    // Enums
    DosarCategoryIcons = DosarCategoryIcons;

    OrderMode = OrderMode;
    currentOrder: OrderMode = OrderMode.DESCENDING; // Descending order by default
    ViewMode = ViewMode;
    currentView: ViewMode = ViewMode.BY_DATE;

    constructor(
        private dialogService: DialogService,
        private dialog: MatDialog,
        private beneficiariService: BeneficiariService,
        private documentCategoriesService: DocumentCategoriesService,
        private documentTagsService: DocumentTagsService,
        private documentSectionsService: DocumentSectionsService,
        private conditieMedicalaService: ConditieMedicalaService,
        private evenimentGenealogicService: EvenimentGenealogicService,
        private relatieTypeService: RelatieTypeService,
        private relatieSpecificaService: RelatieSpecificaService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
        this.fileGroups = this.beneficiar.file_groups;
        this.filteredFileGroups = [...this.fileGroups];

        this.loadDocumentCategories();
        this.loadDocumentSections();
        this.loadDocumentTags();
        this.loadConditieMedicala();
        this.loadEvenimentGenealogic();
        this.loadRelatieType();
        this.loadRelatieSpecifica();

        this.renderFieldsSearch();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.fileGroups = this.beneficiar.file_groups;
        this.filteredFileGroups = [...this.fileGroups];
        this.filterByCategory(this.activeCategory)
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadDocumentCategories() {
        this.isLoading = true;
        this.documentCategoriesService
            .getListActive()
            .pipe(
                map((results: any) => results.data.filter((item: any) => item.show_in_entities === true)),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.documentCategories = results;
                    // Filter categories when loading doc categories
                    this.filterByCategory(this.activeCategory);
                },
                error: (error) => {
                    console.error('Error loading document categories', error);
                },
            });
    }

    loadDocumentSections() {
        this.isLoading = true;
        this.documentSectionsService
            .getListActive()
            .pipe(
                map((results: any) => [...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.documentSections = results;
                },
                error: (error) => {
                    console.error('Error loading document sections', error);
                },
            });
    }

    renderFieldsSearch() {
        this.searchTagsControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredSearchTags = [...this.documentTags];
                    return of(this.filteredSearchTags);
                }
                return this.filterSearchTags(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredSearchTags = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.documentTagsControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                // if (inputValue.length < 1) {
                //     this.filteredDocumentTags = this.documentTags;
                //     return of(this.documentTags);
                // }
                // return this.filterDocumentTags(inputValue);
                this.rebuildFilteredTags(inputValue);
                return of(this.filteredDocumentTags);
            }),
            tap((data: any[]) => {
                this.filteredDocumentTags = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.conditieMedicalaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredConditieMedicala = this.conditieMedicala;
                    return of(this.conditieMedicala);
                }
                return this.filterConditieMedicala(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredConditieMedicala = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.evenimentGenealogicControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredEvenimentGenealogic = this.evenimentGenealogic;
                    return of(this.evenimentGenealogic);
                }
                return this.filterEvenimentGenealogic(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredEvenimentGenealogic = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.relatieTypeControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredRelatieType = this.relatieType;
                    return of(this.relatieType);
                }
                return this.filterRelatieType(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredRelatieType = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.relatieSpecificaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredRelatieSpecifica = this.relatieSpecifica;
                    return of(this.relatieSpecifica);
                }
                return this.filterRelatieSpecifica(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredRelatieSpecifica = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterSearchTags(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.documentTags.filter(item =>
            this.normalizeString(item.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    private rebuildFilteredTags(searchVal?: string): void {
        const available = this.documentTags.filter(
            t => !this.tagArr.some(a => a.id === t.id)
        );
        const withDefault = [this.defaultParameter as any, ...available];
        if (searchVal && searchVal.length >= 1) {
            const norm = this.normalizeString(searchVal);
            this.filteredDocumentTags = [
                this.defaultParameter as any,
                ...available.filter(t => this.normalizeString(t.name).includes(norm)),
            ];
        } else {
            this.filteredDocumentTags = withDefault;
        }
    }

    loadDocumentTags() {
        this.isLoading = true;
        this.documentTagsService
            .getListActive()
            .pipe(
                map((results: any) => [...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.documentTags = results;
                    this.filteredDocumentTags = [this.defaultParameter as any, ...results];
                    this.rebuildFilteredTags();

                    this.filteredSearchTags = [...results];
                },
                error: (error) => {
                    console.error('Error loading tags', error);
                    this.filteredDocumentTags = [];
                    this.filteredSearchTags = [];
                },
            });
    }

    onDocumentTagsClosed() {
        const selectedValue = this.documentTagsControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDocumentTags.some(item =>
                item.id === this.form.get('tag_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.documentTagsControl.setValue(null);
                this.rebuildFilteredTags();
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onSearchTagsClosed() {
        const selectedValue = this.searchTagsControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredSearchTags.some(item =>
                item.id === this.filterTags.value
            );

            if (!isSelectedInFilteredList) {
                this.searchTagsControl.setValue(null);
                this.filteredSearchTags = [...this.documentTags];
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    filterConditieMedicala(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.conditieMedicala.filter(item =>
            this.normalizeString(item.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadConditieMedicala() {
        this.isLoading = true;
        this.conditieMedicalaService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.conditieMedicala = results;
                    this.filteredConditieMedicala = [...this.conditieMedicala];
                },
                error: (error) => {
                    console.error('Error loading conditie medicala', error);
                    this.filteredConditieMedicala = [];
                },
            });
    }

    onConditieMedicalaClosed() {
        const selectedValue = this.conditieMedicalaControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredConditieMedicala.some(item =>
                item.id === this.form.get('medical_condition_type')?.value
            );

            if (!isSelectedInFilteredList) {
                this.conditieMedicalaControl.setValue(null);
                this.filteredConditieMedicala = this.conditieMedicala;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    filterEvenimentGenealogic(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.evenimentGenealogic.filter(item =>
            this.normalizeString(item.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadEvenimentGenealogic() {
        this.isLoading = true;
        this.evenimentGenealogicService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.evenimentGenealogic = results;
                    this.filteredEvenimentGenealogic = [...this.evenimentGenealogic];
                },
                error: (error) => {
                    console.error('Error loading eveniment genealogic', error);
                    this.filteredEvenimentGenealogic = [];
                },
            });
    }

    onEvenimentGenealogicClosed() {
        const selectedValue = this.evenimentGenealogicControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredEvenimentGenealogic.some(item =>
                item.id === this.form.get('genealogical_event_type')?.value
            );

            if (!isSelectedInFilteredList) {
                this.evenimentGenealogicControl.setValue(null);
                this.filteredEvenimentGenealogic = this.evenimentGenealogic;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    filterRelatieType(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.relatieType.filter(item =>
            this.normalizeString(item.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadRelatieType() {
        this.isLoading = true;
        this.relatieTypeService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.relatieType = results;
                    this.filteredRelatieType = [...this.relatieType];
                },
                error: (error) => {
                    console.error('Error loading tipuri relatie', error);
                    this.filteredRelatieType = [];
                },
            });
    }

    onRelatieTypeClosed() {
        const selectedValue = this.relatieTypeControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredRelatieType.some(item =>
                item.id === this.involvedPersonForm.get('relationship_type_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.relatieTypeControl.setValue(null);
                this.filteredRelatieType = this.relatieType;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onRelatieTypeChange(selectedId: number) {
        if (selectedId) {
            const selectedItem = this.relatieType.find(item => item.id === selectedId);

            if (selectedItem) {
                this.involvedPersonForm.get('relationship_type_name')?.patchValue(selectedItem.name);
            }
        }
    }

    filterRelatieSpecifica(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.relatieSpecifica.filter(item =>
            this.normalizeString(item.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadRelatieSpecifica() {
        this.isLoading = true;
        this.relatieSpecificaService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results.data]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.relatieSpecifica = results;
                    this.filteredRelatieSpecifica = [...this.relatieSpecifica];
                },
                error: (error) => {
                    console.error('Error loading tipuri relatie', error);
                    this.filteredRelatieSpecifica = [];
                },
            });
    }

    onRelatieSpecificaClosed() {
        const selectedValue = this.relatieSpecificaControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredRelatieSpecifica.some(item =>
                item.id === this.involvedPersonForm.get('relationship_specific_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.relatieSpecificaControl.setValue(null);
                this.filteredRelatieSpecifica = this.relatieSpecifica;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onRelatieSpecificaChange(selectedId: number) {
        if (selectedId) {
            const selectedItem = this.relatieSpecifica.find(item => item.id === selectedId);

            if (selectedItem) {
                this.involvedPersonForm.get('relationship_specific_name')?.patchValue(selectedItem.name);
            }
        }
    }

    filterByCategory(catSlug: string | null): void {
        this.activeCategory = catSlug;
        this.applyFilters();
    }

    onFilterChange() {
        this.applyFilters();
    }

    applyFilters(): void {
        const setDocCat = new Set<string>();
        this.documentCategories.forEach((cat) => setDocCat.add(cat.slug));

        const from = this.dateFrom.value ? new Date(this.dateFrom.value).setHours(0, 0, 0, 0) : null;
        const to = this.dateTo.value ? new Date(this.dateTo.value).setHours(23, 59, 59, 999) : null;
        const tagId = this.filterTags.value ? Number(this.filterTags.value) : null;

        this.filteredFileGroups = this.fileGroups.filter((doc: FileGroup) => {
            const createdAt = new Date(doc.created_at).getTime();

            if (!setDocCat.has(doc.category_slug)) return false;
            if (this.activeCategory && doc.category_slug !== this.activeCategory) return false;
            if (from !== null && createdAt <= from) return false;
            if (to !== null && createdAt >= to) return false;
            if (tagId !== null && tagId !== -1 && !doc.tags.some(t => t.id === tagId)) return false;

            return true;
        });

        this.sortFileGroups();
    }

    setOrder(mode: OrderMode): void {
        this.currentOrder = mode;
        this.sortFileGroups();
    }

    private sortFileGroups(): void {
        this.filteredFileGroups.sort(
            (a, b) => this.currentOrder * (new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
        );

        this.buildGroups();
    }

    setViewMode(mode: ViewMode): void {
        this.currentView = mode;
        this.buildGroups();
    }

    buildGroups(): void {
        switch (this.currentView) {
            case ViewMode.BY_CATEGORY:
                this.groupByCategory();
                break;
            case ViewMode.BY_DATE:
                this.groupByDate();
                break;
            case ViewMode.BY_TAG:
                this.groupByTag();
                break;
            case ViewMode.BY_UPLOADER:
                this.groupByUploader();
                break;
        }
    }

    private groupByCategory(): void {
        const mapDocCat = new Map<string, FileGroup[]>();
        this.documentCategories.forEach((cat) => mapDocCat.set(cat.slug, []));

        this.filteredFileGroups.forEach((doc) => {
            const list = mapDocCat.get(doc.category_slug) || [];
            list.push(doc);
            mapDocCat.set(doc.category_slug, list);
        });

        this.viewCards = this.documentCategories
            .filter((cat) => (mapDocCat.get(cat.slug)?.length || 0) > 0)
            .map((cat) => {
                const docs = mapDocCat.get(cat.slug)!;
                const group: ViewCard = {
                    label: cat.name,
                    icon: DosarCategoryIcons[cat.slug],
                    fileGroups: docs,
                };

                return group;
            });
    }

    private groupByDate(): void {
        // Group by day-month-year
        const map = new Map<string, FileGroup[]>();
        this.filteredFileGroups.forEach((doc) => {
            const d = new Date(doc.created_at);
            const key = `${d.getDate()} ${d.toLocaleString('ro-RO', { month: 'long' })} ${d.getFullYear()}`;
            if (!map.has(key)) map.set(key, []);
            map.get(key)!.push(doc);
        });

        this.viewCards = Array.from(map.entries()).map(([label, fileGroups]) => ({
            label,
            icon: 'fa-calendar',
            fileGroups,
        }));
    }

    private groupByTag(): void {
        const map = new Map<number, { name: string; color: string; docs: FileGroup[] }>();
        this.filteredFileGroups.forEach((doc) => {
            const tagIds = doc.tags.map(tag => tag.id);
            for (let tagId of tagIds) {
                // Add each tag id to the Map
                if (!map.has(tagId)) {
                    const tagValue = doc.tags.find(tag => tag.id === tagId)
                    map.set(tagId, { name: tagValue!.name, color: tagValue!.color, docs: [] });
                }
                map.get(tagId)!.docs.push(doc);
            }
        });

        this.viewCards = Array.from(map.values()).map((entry) => ({
            label: entry.name,
            color: entry.color,
            fileGroups: entry.docs,
        }));
    }

    private groupByUploader(): void {
        // const map = new Map<number, { name: string; docs: FileGroup[] }>();
        // this.filteredFileGroups.forEach((doc) => {
        //     const uid = doc.uploaded_by.id;
        //     if (!map.has(uid)) {
        //         map.set(uid, { name: doc.uploaded_by.full_name, docs: [] });
        //     }
        //     map.get(uid)!.docs.push(doc);
        // });

        // this.viewCards = Array.from(map.values()).map((entry) => ({
        //     label: entry.name,
        //     icon: 'fa-user',
        //     fileGroups: entry.docs,
        // }));
    }

    toggleUploadPanel(): void {
        this.showUploadPanel = !this.showUploadPanel;
        if (!this.showUploadPanel) {
            this.resetUploadForm();
        }
    }

    openEditPanel(editData: FileGroup): void {
        this.editData = editData;
        this.showUploadPanel = true;

        this.onCategoryChange(editData.category_id);

        this.form.patchValue({
            // General
            category_id: editData.category_id,
            category_slug: editData.category_slug,
            tag_id: -1,
            document_nr: editData.document_nr || '',
            document_date: editData.document_date || '',
            observations: editData.observations || '',
            // Medical
            medical_section: editData.metadata.medical_section || -1,
            medical_condition_type: editData.metadata.medical_condition_type || -1,
            genealogical_event_type: editData.metadata.genealogical_event_type || -1,
            doctor_name: editData.metadata.doctor_name || '',
            clinic_name: editData.metadata.clinic_name || '',
            diagnosis: editData.metadata.diagnosis || '',
            treatment: editData.metadata.treatment || '',
            date_next_checkup: editData.metadata.date_next_checkup || null,
            // Educational
            institution_name: editData.metadata.institution_name || '',
            location: editData.metadata.location || '',
            date_from: editData.metadata.date_from || null,
            date_to: editData.metadata.date_to || null,
            edu_status: editData.metadata.edu_status || -1,
            degree_type: editData.metadata.degree_type || '',
            specialization: editData.metadata.specialization || '',
            has_breaks: editData.metadata.has_breaks || false,
            break_details: editData.metadata.break_details || '',
            // Juridic
            court_name: editData.metadata.court_name || '',
            // Psihologic
            specialist_name: editData.metadata.specialist_name || '',
            evaluation_type: editData.metadata.evaluation_type || '',
            recommendations: editData.metadata.recommendations || '',
            // Familial
            document_subtype: editData.metadata.document_subtype || '',
        });

        if (editData.tags && editData.tags.length) {
            this.tagArr = [...editData.tags];
            this.rebuildFilteredTags();
        }

        if (editData.metadata.involved_persons && editData.metadata.involved_persons.length) {
            this.involvedPersons = [...editData.metadata.involved_persons];
        }

        this.uploadedFiles = [...editData.files];
    }

    onCategoryChange(catId: number): void {
        this.resetMetadataValues();
        this.clearValidators(['medical_section']);

        const cat = this.documentCategories.find(doc => doc.id === catId);
        this.activeCategorySelect = cat ? cat.slug : null;
        this.form.get('category_slug')?.patchValue(this.activeCategorySelect);

        if (this.activeCategorySelect === 'dosar-medical') {
            const medical_section = this.form.get('medical_section');
            medical_section?.setValidators([Validators.required, notDefaultValidator('-1')]);
            medical_section?.markAsUntouched();
        }

        Object.keys(this.form.controls).forEach(key => {
            this.form.get(key)?.updateValueAndValidity();
        });
    }

    private clearValidators(fields: string[]): void {
        fields.forEach(field => {
            this.form.get(field)?.clearValidators();
            this.form.get(field)?.updateValueAndValidity();
        });
    }

    private resetMetadataValues(): void {
        this.form.patchValue({
            // Medical
            medical_section: -1,
            medical_condition_type: -1,
            genealogical_event_type: -1,
            doctor_name: '',
            clinic_name: '',
            diagnosis: '',
            treatment: '',
            date_next_checkup: null,
            // Educational
            institution_name: '',
            location: '',
            date_from: null,
            date_to: null,
            edu_status: -1,
            degree_type: '',
            specialization: '',
            has_breaks: false,
            break_details: '',
            // Juridic
            court_name: '',
            // Psihologic
            specialist_name: '',
            evaluation_type: '',
            recommendations: '',
            // Familial
            document_subtype: '',
        });
    }

    addTagInArray() {
        const tagIdValue: number = this.form.controls['tag_id'].value;

        if (!tagIdValue || tagIdValue === -1) return;

        const existing = this.tagArr.find((item: Tag) => item.id === tagIdValue);

        if (existing) {
            return;
        } else {
            const tag = this.documentTags.find((item: Tag) => item.id === tagIdValue);
            if (tag) {
                const tagItem = { ...tag };
                this.tagArr.push(tagItem);
                // Reset select back to default and remove the tag from the available list
                this.form.controls['tag_id'].setValue(-1);
                this.rebuildFilteredTags();
            };
        }
    }

    removeTagInArray(index: number) {
        this.tagArr.splice(index, 1);
        // Add the removed tag back into the available list
        this.rebuildFilteredTags();
    }

    addTagToNomenclator(): void {
        const dialogRef = this.dialog.open(AddDocumentTagsComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.loadDocumentTags();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    addInvolvedPerson(): void {
        const foundExistingCnp = this.involvedPersons.find(person => person.cnp && person.cnp === this.involvedPersonForm.value.cnp);

        if (this.involvedPersonForm.valid && !foundExistingCnp) {
            const person: InvolvedPerson = {
                full_name: this.involvedPersonForm.value.full_name,
                cnp: this.involvedPersonForm.value.cnp,
                relationship_type_id: this.involvedPersonForm.value.relationship_type_id,
                relationship_type_name: this.involvedPersonForm.value.relationship_type_name,
                relationship_specific_id: this.involvedPersonForm.value.relationship_specific_id,
                relationship_specific_name: this.involvedPersonForm.value.relationship_specific_name,
            };

            this.involvedPersons.push(person);

            // Reset form after adding
            this.involvedPersonForm.reset({
                full_name: '',
                cnp: '',
                relationship_type_id: -1,
                relationship_type_name: '',
                relationship_specific_id: -1,
                relationship_specific_name: '',
            });
        }
    }

    removeInvolvedPerson(index: number): void {
        this.involvedPersons.splice(index, 1);
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.filesForm.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.beneficiariService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.filesForm.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        // Handle error cases here
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    removeFile(index: number) {
        const files = this.filesForm.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    downloadTempFile(uploadedFile: FileUpload) {
        this.isLoading = true;
        const fullPath = this.beneficiariService.tempFileDownloadUrl;

        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    downloadFile(id: number) {
        this.isLoading = true;
        const fullPath = this.beneficiariService.downloadFileUrl + id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    deleteFile(index: number) {
        const fileToDelete = this.uploadedFiles[index];
        this.uploadedFiles.splice(index, 1);
        this.deletedFiles.push(fileToDelete);
    }

    restoreFile(index: number) {
        const fileToAddBack = this.deletedFiles[index];
        this.deletedFiles.splice(index, 1);
        this.uploadedFiles.push(fileToAddBack);
    }

    private resetUploadForm(): void {
        this.resetGeneralData();
        this.onCategoryChange(-1);

        this.tagArr = [];
        this.rebuildFilteredTags();
        this.involvedPersons = [];

        (this.filesForm.get('files') as FormArray).clear();

        if (this.editData) {
            this.editData = null;
            this.uploadedFiles = [];
            this.deletedFiles = [];
        }
    }

    private resetGeneralData(): void {
        this.form.patchValue({
            category_id: -1,
            category_slug: '',
            tag_id: -1,
            document_nr: '',
            document_date: null,
            observations: '',
        });

        const category_id = this.form.get('category_id');
        const tag_id = this.form.get('tag_id');

        category_id?.markAsUntouched();
        tag_id?.markAsUntouched();
    }

    submitUpload(): void {
        this.isLoading = true;

        const payload = {
            ...this.form.value,
            tag_id: this.tagArr.map(tag => tag.id), // Send the ids from tagArr in place of tag_id
            involved_persons: this.involvedPersons,
            files: this.filesForm.value.files,

            // For edit only
            deleted_file_ids: this.editData ? this.deletedFiles.map(file => file.id) : undefined,
        }

        const routeType = this.editData ? this.beneficiariService.updateFiles(this.beneficiar.id, this.editData.id, payload) : this.beneficiariService.storeFiles(this.beneficiar.id, payload);
        routeType
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.toggleUploadPanel();
                    this.beneficiarChanged.emit();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    deleteDocument(group: FileGroup) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // this.beneficiariService.deleteDocument(group.id).subscribe({
                //     next: () => {
                //         this.beneficiarChanged.emit();
                //         Swal.fire({
                //             title: 'Șters!',
                //             text: 'Document șters cu succes.',
                //             icon: 'success',
                //             confirmButtonText: 'OK',
                //         });
                //     },
                //     error: (err: any) => {
                //         let msg;
                //         try {
                //             // try to catch the message from server
                //             msg = err.error.errors.message[0];
                //         } catch (error) {
                //             // controll output message
                //             msg = helper.dialogConfig.generalMessages.error;
                //         }
                //         Swal.fire({
                //             title: helper.dialogConfig.headers.errorAtentie,
                //             text: msg,
                //             icon: 'error',
                //             confirmButtonText: helper.dialogConfig.buttonLabels.close,
                //         })
                //     }
                // });
            }
        });
    }

    viewDocument(group: FileGroup) {
        const dialogRef = this.dialog.open(ViewDocumentComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                group,
                documentSections: this.documentSections,
                conditieMedicala: this.conditieMedicala,
                evenimentGenealogic: this.evenimentGenealogic,
                relatieType: this.relatieType,
                relatieSpecifica: this.relatieSpecifica,
            },
        });
    }

    openIstoricDocument(group: FileGroup) {
        // const dialogRef = this.dialog.open(ViewIstoricDocumentComponent, {
        //     width: '700px',
        //     maxWidth: '80vw',
        //     minHeight: '200px',
        //     maxHeight: '90vh',
        //     autoFocus: false,
        //     disableClose: true,
        //     data: { group: group },
        // });
        // dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
        //     if (success) {
        //         this.beneficiarChanged.emit();
        //     }
        // });
    }
}
